import { styled } from 'linaria/react';
import { css } from 'linaria';

export const InputContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: var(--space-200);
  width: 100%;

  @media (--only-mobile) {
    gap: var(--space-150);
  }
`;

export const InputContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 48.5%;
  width: 100%;

  @media (--only-mobile) {
    flex-basis: 100%;
  }
`;

export const ButtonContainer = styled.div`
  margin-bottom: var(--space-350);
`;

export const styledTabList = css`
  button {
    &:first-child {
      margin-left: 0 !important;
    }
  }
`;
